import { IBase, IBasePublishable } from './base'
import { IBenefit } from './benefit'

export enum CREDIT_PROGRAM_FORM_TYPE_ENUM {
	FORM_KREDIT_BALIK = 'formkreditbalik'
}

export interface IMedanteCreditProgram extends IBase, IBasePublishable {
	name: string
	aladarTitle: string
	aladarId: number
	aladarIde: number
	isPublishedDynamic: boolean
	price: number
	credit: number
	status: number
	isForWeb: boolean
	formType: CREDIT_PROGRAM_FORM_TYPE_ENUM
	maxCustomers: number
	expirationMonths: number | null
	benefits: IBenefit[]
	isExpanded: boolean | undefined
	isFeatured: boolean
	url?: string
}

export interface IMedanteCreditProgramDetail extends IMedanteCreditProgram {}
